import  React, { useEffect } from "react";
import { useFilter,  } from "@sajari/react-hooks";
import { Results, Input, Filter, Summary, Sorting, Pagination  } from "@sajari/react-search-ui";
import { CheckboxGroup, Checkbox } from '@sajari/react-components';
import { Radio, RadioGroup } from '@sajari/react-components';
import './app.css';

function App({gettype, selectedtype}) {
  const kcFilters = ["Articles","Video","Publications","Inside RGA","Research and White Papers"];
  const isKCSearch = kcFilters.some(r=> selectedtype.includes(r));
  const [lastFilter, setLastFilter] = React.useState("");

/* Custom Filter Rendering
================================================================ */
    const SelectedFilter = React.memo(({ name, title }) => {
        const { multi, selected, setSelected } = useFilter(name);    
        if (selected.length === 0) {
        return null;
        }

        const Group = multi ? CheckboxGroup : RadioGroup;
        const Control = multi ? Checkbox : Radio;    

        return (
            <Group className="search-filter__selection-grp" name={name} value={selected} label={`${title} Selections`} disableDefaultStyles={true} onChange={multi ? setSelected : (e) => setSelected([e.target.value])}>
                {selected.map((title) => { 
                    const splitTitle = title.split('|');
                    const lastItem = splitTitle[splitTitle.length - 1];
                    const newTitle = title.indexOf('|') > -1 ? lastItem : title;
                    return (
                      
                        <div className="search-filter__selected">
                            <Control className="search-filter__chk" value={title} checked={selected.includes(title)} onChange={() => {}} aria-label={`Remove ${title}`}>
                                {newTitle}
                            </Control>
                        </div>
                )})}
            </Group>
        );
    });

    const HierarchicalFilter = React.memo(({ name, title, toggleId, isOpen = false}) => {
        const { multi, options, selected, setSelected, reset } = useFilter(name);
        const Group = multi ? CheckboxGroup : RadioGroup;
        const Control = multi ? Checkbox : Radio;
        let count = 0;

        const TreeNode = ({ node }) => {
            count++;

            const title = node.title;
            const value = node.value;
            const children = node.children;
            const hasSub = node.children.length > 0;
            const isChecked = selected.includes(value);

            return (
                <>
                    {hasSub && (
                        <div className="filter__list-group">
                            <div className="filter__list-group-header">
                                <Control 
                                    value={value} 
                                    checked={isChecked}
                                    onChange={() => { setLastFilter(value); }}
                                >
                                    {title}
                                </Control>

                                <button type="button" className="filter-toggle" id={`${name}-${count}-btn`}>
                                    <span className="visually-hidden">Expand/Collapse {title}</span>
                                </button>
                            </div>
                            <div 
                                className="filter__list-sub" 
                                aria-labelledby={`${name}-${count}-btn`}
                            >
                                {children.map(child => (
                                    <div className="filter__checkbox" key={child.value + child.count}>
                                        <TreeNode node={child}/>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    
                    {!hasSub && (     
                        <Control 
                            value={value} 
                            checked={selected.includes(value)}
                            onChange={() => { setLastFilter(value) }}
                        >
                            {title}
                        </Control>
                    )}
                </>
            );
        }

        const constructArray = (optionsArray) => {
            let result = [];
            
            optionsArray.forEach(obj => {
                if(obj.label !== "") {
                    let parts = obj.label.split("|");
                    let current = result;

                    parts.forEach(part => {
                        let child = current.find(c => c.title === part);
                
                        if (!child) {
                            child = { title: part, count: obj.count, value: obj.label, children: [] };
                            current.push(child);
                        }
                
                        current = child.children;
                    });
                }
            });
            
            return result;
        }

        const hierarchicalOptions = constructArray(options);

        return (
            <>
                {title && (
                    <h2 class="search-results__filters-title">
                        {title}
                    </h2>
                )}
                <div className={`filter${isOpen ? ' filter--expanded' : ''}`}>
                    <div className="filter__header">
                        {selected.length > 0 && multi ? (
                            <button
                                className="filter__reset"
                                onClick={reset}
                                >
                                Reset
                            </button>            
                        ) : null}
                    </div>
                    <div className="filter__list">
                        <Group 
                            className="filter__list-group filter__list-group--checkbox" 
                            name={name} 
                            value={selected} 
                            aria-labelledby={toggleId}
                            onChange={multi ? setSelected : (e) => setSelected([e.target.value])}
                        >
                            {hierarchicalOptions.map((filter) => (
                                <div className="filter__checkbox" key={filter.value + filter.count}>
                                    <TreeNode node={filter}/>
                                </div>
                            ))}
                        </Group>
                    </div>       
                </div>
            </>
        )

    });

/* Filter Toggle Functionality
================================================================ */
    /** When filter toggles are clicked **/
    const filterToggleClick = (e) => {
    const target = e.target;
    const activeClass = 'active';
    const validElement = target.classList.contains('filter-toggle') ? true : false;
    const isReset = target.classList.contains("filter__reset") ? true : false;
    const isShowMore = target.classList.contains("filter__show-toggle") ? true : false;
    let resetContainer = document.getElementById("reset-msg");
    resetContainer.innerHTML = "";

    function classHandler (toggle){
        const isHeader = toggle.classList.contains('filter-toggle--header') ? true : false;

        if(toggle.getAttribute('aria-expanded') === 'true'){
            if(isHeader){
                toggle.classList.remove(activeClass)
            }
            else {
                toggle.parentElement.classList.remove(activeClass);
            }
            
            toggle.setAttribute('aria-expanded', 'false');
        }
        else {
            if(isHeader){
                toggle.classList.add(activeClass)
            }
            else {
                toggle.parentElement.classList.add(activeClass);
            }
            toggle.setAttribute('aria-expanded', 'true');
        }
    }

    function resetMessage (resetBtn){    
      resetContainer.innerHTML = "Filters have been reset.";
    }

    function showMoreMessage (showBtn){    
      if(showBtn.classList.contains("less")) {
        showBtn.classList.remove("less");
        showBtn.classList.add("more");
        resetContainer.innerHTML = "Show more items.";
      } else {
        showBtn.classList.remove("add");
        showBtn.classList.add("less");
        resetContainer.innerHTML = "Hide more items.";
      }
      
    }

    if(validElement){
        classHandler(target);
    }

    if(isReset) {
      resetMessage(target);
    }

    if(isShowMore) {
      showMoreMessage(target);
    }

    }

    const container = document.querySelector('#searchio-results');
    if(container && container.dataset.initialized !== 'true'){ 
        container.setAttribute('data-initialized', 'true');
        container.addEventListener('click', filterToggleClick);
    }

    /** Reopen filters on re-render **/
    const setInputs = (filter, inputs) => {
        const headerToggle = filter.querySelector('.filter-toggle--header');

        // check if any inputs are checked and open filter-toggle--header
        if(Array.from(inputs).some(input => input.checked) && !filter.classList.contains('filter-group--expanded')) {
            headerToggle.classList.add("active");
            headerToggle.setAttribute('aria-expanded', 'true');
        }

        inputs.forEach(input => {
            if(input.getAttribute('aria-checked') === 'true' && input.parentElement.closest('.filter__list-group-header') === null && input.closest('.filter__list-sub')) {
                const parentHeader = input.closest('.filter__list-sub').previousElementSibling;
                
                if(parentHeader){
                    parentHeader.classList.add('active');
                    parentHeader.querySelector('.filter-toggle').setAttribute('aria-expanded', 'true');
                }
            }
        })
    }

    const setFilters = () => {
        const filters = document.querySelectorAll(".filter-group");

        filters.forEach(filter => {
            const inputs = filter.querySelectorAll("input[type='checkbox']");

            setInputs(filter, inputs);
        });
    }


/* Result Item Templates
================================================================ */
  const defaultTemp = {
    html: `
    {{#expect articledate}}
        <div class="search-results__item">
          {{#if image != null && image != ""}}
              <div class="search-results__item-media">
                  <img src="{{image}}" class="search-results__item-img" alt="{{imagealt}}"/>
              </div>
          {{/if}}
          <div class="search-results__item-content">  
            <div class="search-results__item-meta">
              {{#if contenttype != null && contenttype != ""}}
                <span class="search-results__item-type">{{contenttype}}</span> 
              {{/if}}

              {{#if articledate != null}}
                <span class="search-results__item-date">{{#date value=articledate format="MMMM YYYY"}}</span>
              {{/if}}
            </div>

            <h3 class="search-results__item-title">
                <a href="{{url}}">{{{title}}}</a>
            </h3>
            
            {{#if description != null && description != ""}}
              <div class="search-results__item-summary">{{description}}</div>
            {{/if}}
          </div>
        </div>
    `
  }

  const personTemp = {
    html: `
    {{#expect personbio}}
        {{#if image != null && image != ""}}
            <div class="people__media">
                <img src="{{image}}" class="people__img" alt="{{imagealt}}"/>
            </div>
        {{/if}}

        <div class="people__content"> 
            {{#if firstname != null && firstname != "" && lastname != null && lastname != "" }}
                <h3 class="people__name">
                    {{{firstname}}} {{{lastname}}}
                </h3>
            {{/if}}

            {{#if companyinfo != null && companyinfo != ""}}
                <div class="people__info">
                    {{{companyinfo}}}
                </div>
            {{/if}}

            <div class="people__actions">
                {{#if personcontacturl != null && personcontacturl != ""}}
                    <div class="people__contact">
                        <a href="{{personcontacturl}}" class="people__contact-link" aria-label="{{{title}}}">
                            Contact 
                            <svg class="icon icon-arrow" focusable="false" aria-hidden="true">
                                <use href="/ResourcePackages/Talon/assets/dist/sprites/svgdefs.svg#icon-arrow_forward"></use>
                            </svg>
                        </a>                
                    </div>
                {{/if}}

                {{#if personbio != null && personbio != ""}}
                    <a href="{{url}}" class="people__bio">
                        Bio
                        <span class="visually-hidden">for {{{title}}}</span>
                        <svg class="icon icon-arrow" focusable="false" aria-hidden="true">
                            <use href="/ResourcePackages/Talon/assets/dist/sprites/svgdefs.svg#icon-arrow_forward"></use>
                        </svg>
                    </a>
                {{/if}}
            </div>    
        </div>
        {{#if personlinkedin != null && personlinkedin != ""}}
            <div class="people__actions-link">
                <a href="{{personlinkedin}}" class="people__linkedin">
                    <svg class="icon icon-linkedin" focusable="false" aria-hidden="true">
                        <use href="/ResourcePackages/Talon/assets/dist/sprites/brands.svg#linkedin"></use>
                    </svg>
                    <span class="visually-hidden">LinkedIn for {{{Title}}}</span>
                </a>
            </div>
        {{/if}}
    `
  }

  const solutionTemp = {
    html: `
    {{#expect displaytitle}}
          <div class="solutions__content">  
            <h3 class="solutions__title">
                {{#if displaytitle != "" && displaytitle != undefined}}
                    {{{displaytitle}}}
                {{#else}}
                    {{{title}}}
                {{/if}}
            </h3>

            {{#if description != null && description != ""}}
              <div class="solutions__description">{{{description}}}</div>
            {{/if}}

            <div class="solutions__actions">
              <div class="solutions__actions-btn">
              {{#if ctalinktext != null && ctalinktext != ""}}
                {{#if ctalink != "" && ctapageurl == ""}}
                  <a href="{{ctalink}}" class="button" target="_blank">{{ctalinktext}}</a>
                {{/if}}

                {{#if ctapageurl != ""}}
                  <a href="{{ctapageurl}}" class="button">{{ctalinktext}}</a>
                {{/if}}

              {{/if}}
              </div>

              <div class="solutions__actions-btn">
              {{#if contactlinktext != null && contactlinktext != ""}}
                {{#if contactlink != "" && contactpageurl == ""}}
                  <a href="{{contactlink}}" class="button" target="_blank">{{contactlinktext}}</a>
                {{/if}}

                {{#if contactpageurl != ""}}
                  <a href="{{contactpageurl}}" class="button">{{contactlinktext}}</a>
                {{/if}}
              {{/if}}           
            </div>

            </div>          
   
          </div>
    `
  }

/* Filter Templates
================================================================ */
  const solutionFilters = React.memo(() => {
    return (
      <>
        <div className="search-results__filters filters--expanded filters--alt">
           <div className="filter-group filter-group--hier filter-group--expanded">
            <HierarchicalFilter name="region" title="Regions" isOpen={true}/>
           </div>
        </div>
        <div className="search-results__filters">
          <div className="filter-group filter-group--hier filter-group--expanded">
            <HierarchicalFilter name="solutionareas" title="Solution Areas" isOpen={true}/>
          </div>
        </div>      
      </>
    )
  });

  const peopleFilters = React.memo(() => {
    return (
      <>
        <div className="search-results__filters filters--expanded filters--alt">
           <div className="filter-group filter-group--hier filter-group--expanded">
            <HierarchicalFilter name="region" title="Regions" isOpen={true}/>
           </div>
        </div>     
      </>
    )
  });

  const articleFilters = React.memo(() => {
    return (
      <>
        <div className="search-results__filters">  
          <h2 className="search-results__filters-title">Filter By</h2>
          
            <div className="filter-group">
              <button type="button" className="filter-toggle filter-toggle--header" id="categoriesToggle" aria-expanded="false">
                Category
              </button>
              <Filter name="categories" title="Categories" hideCount="true" searchable={false} pinSelected={false} />   
            </div>  
            <div className="filter-group">
              <button type="button" className="filter-toggle filter-toggle--header" id="authorsToggle" aria-expanded="false">
                Authors
              </button>
              <Filter name="authors" title="Authors" hideCount={false} searchable={false} pinSelected={false} />   
            </div>
            <div className="filter-group filter-group--hier">   
              <button type="button" className="filter-toggle filter-toggle--header" id="regionToggle" aria-expanded="false">
                Regions
              </button>           
              <HierarchicalFilter name="region" toggleId="regionToggle"/>   
            </div>
            <div className="filter-group">
              <button type="button" className="filter-toggle filter-toggle--header" id="contentToggle" aria-expanded="false">
                Content Type
              </button>   
              <Filter name="contenttype" title="Content Type" hideCount="true" searchable={false} pinSelected={false} />      
            </div>    
            <div className="filter-group">
              <button type="button" className="filter-toggle filter-toggle--header" id="yearToggle" aria-expanded="false">
                Year
              </button>   
              <Filter name="publishyear" title="Year" hideCount="true" searchable={false} pinSelected={false} sort="alpha" sortAscending={false} />      
            </div>         
           
            <div className="filter-group filter-group--hier">
              <button type="button" className="filter-toggle filter-toggle--header" id="solutionToggle" aria-expanded="false">
                Solution Areas
              </button> 
              <HierarchicalFilter name="solutionareas" toggleId="solutionToggle"/>
            </div> 
        </div>       
      </>
    )
  });

  const generalFilters = () => {
    return (
      <>
        <div className="search-results__filters">  
            <h2 className="search-results__filters-title">
                Filter By
            </h2>

            <div className="filter-group">
              <button type="button" className="filter-toggle filter-toggle--header" id="categoriesToggle" aria-expanded="false">
                Category
              </button>
              <Filter name="categories" title="Categories" hideCount="true" searchable={false} pinSelected={false} />   
            </div>

            <div className="filter-group filter-group--hier">
              <button type="button" className="filter-toggle filter-toggle--header" id="regionsToggle" aria-expanded="false">
                Region
              </button>   
             <HierarchicalFilter name="region" toggleId="regionsToggle"/>
            </div>

            <div className="filter-group">
              <button type="button" className="filter-toggle filter-toggle--header" id="yearToggle" aria-expanded="false">
                Year
              </button>   
              <Filter name="publishyear" title="Year" hideCount="true" searchable={false} pinSelected={false} sort="alpha" sortAscending={false} />      
            </div>   

            <div className="filter-group">
              <button type="button" className="filter-toggle filter-toggle--header" id="contentToggle" aria-expanded="false">
                Content Type
              </button>   
              <Filter name="contenttype" title="Content Type" hideCount="true" searchable={false} pinSelected={false} />      
            </div>   

            <div className="filter-group filter-group--hier">
              <button type="button" className="filter-toggle filter-toggle--header" id="solutionToggle" aria-expanded="false">
                Solution Areas
              </button> 
              <HierarchicalFilter name="solutionareas" toggleId="solutionToggle"/>
            </div> 
        </div>
      </>
    )
  };

/* Sort and Filter Logic
================================================================ */
    let sortOptions = 
    [
        { name: 'Most relevant', value: '' },
        { name: 'Title: A to Z', value: 'title' },
        { name: 'Title: Z to A', value: '-title' }
    ];

    let template = defaultTemp;
    let ShowFilters = generalFilters;

    if(gettype === "Solution") {
        template = solutionTemp;
        ShowFilters = solutionFilters;
    } else if(gettype === "Person") {
        template = personTemp;
        ShowFilters = peopleFilters;
    } else if(isKCSearch) {
        template = defaultTemp;
        ShowFilters = articleFilters;  
        sortOptions.unshift({ name: 'Least recent', value: 'articledate' });
        sortOptions.unshift({ name: 'Most recent', value: '-articledate' });
    }

/* App Render
================================================================ */
  useEffect(() => {
    if(lastFilter !== "") {
        setTimeout(function(){
            document.querySelector(`[value="${lastFilter}"]`).focus();
        }, 600)
    }
  });

  useEffect(() => {
    setTimeout(() => {
        setFilters();
    }, 300)
  })

  return (
    <div className="search-results">  
      <div className="search-results__rail">  
        <div className="search-results__input search-results__input--mobile">
            <Input placeholder="enter search keywords..." className="search-results__input-field" autoComplete="off"/>       
        </div>   
        <ShowFilters />
      </div>

      <div className="search-results__content">
        <div className="search-results__input">
          <Input placeholder="enter search keywords..." className="search-results__input-field" autoComplete="off"/>       
        </div>

        <div className="search-results__option">
            <div className="search-results__selections">
                <span id="reset-msg" className="sr-only" aria-atomic="true" aria-live="polite"></span>
                <SelectedFilter name="solutionareas" title="Solution Area" />
                <SelectedFilter name="region" title="Region" />
                <SelectedFilter name="publishyear" title="Year" />
                <SelectedFilter name="categories" title="Cateogry" />
                <SelectedFilter name="contenttype" title="Content Type" />
            </div>

            <Summary className="search-results__total" />

            <Sorting
            type="select"
            label="Sort By"
            options={sortOptions}
            />
        </div>

        <div className="search-results__list">
          <Results resultTemplate={template}  appearance='list' disableDefaultStyles={true}/>          
        </div>

        <Pagination className="search-results__pagination" />        
      </div>
    </div>
  );
}

export default App;
